/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenImportsCtrlPreview", [
		"$scope", "toastr", "Utils", "$uibModal", "OpenImportsService", "AdminClientsService", "$location","$controller",  "$timeout", "SharedProperties",
	function ($scope, toastr, Utils, $uibModal, OpenImportsService, AdminClientsService, $location,$controller,  $timeout, SharedProperties) {

		$controller("JobsCtrlParent", {$scope: $scope});

		$scope.status = {
			isActionReportErrorOpen: true,
			isPeriodeExploitationOpen: true,
			isLinesOpen: false,
			isNewStopsOpen: false,
			isStopsOpen: false,
			isGeolocErrorOpen: false,
			isChangedNameStopAreasOpen: false,
			isStopCodesErrorOpen: false,
			isQuayDifferentTransportModesErrorOpen: false,
			isStopPlaceDifferentTransportModesErrorOpen: false,
			isMultipleUsedTimetableDBErrorOpen : false,
			isMultipleUsedTimetableFileErrorOpen : false,
			isTimetableModificationsErrorOpen :false,
			isMissingRouteLinksErrorOpen: false,
			isWrongRouteLinksUsedInMutipleFilesErrorOpen: false,
			isWrongRouteLinksUsedMutipleTimesInTheSameFileErrorOpen: false,
			isWrongRouteLinksUsedSameFromAndToScheduledStopPointErrorOpen: false,
			isWrongScheduleStopPointCoordinatesErrorOpen: false,
			isWrongStopPointOrderInJourneyPatternErrorOpen: false,
			isWrongRefStopAreaInScheduleStopPointOpen: false,
			isStopPlacesWithoutQuayErrorOpen: false,
			isMultimodalStopPlacesOpen: false,
			isEmptyPointsInJourneySequenceOpen: false,
			isEmptyPassingTimesOpen: false,
			isParametersImportsOpen:false,
			isChangedTripsOpen: false,
			isSelfReferencingStopsOpen : false,
			isDuplicateConsecutiveStopTimesOpen: false,
			isDuplicateTripStructureInStopTimesWithSameCalendarAndHourly: false,
			isStopPointsPassingTimesDifference: false,
			isInconsistentTimeProgressOpen: false,
			isNotEnoughRoutePointsForTrip: false
		};

		$scope.data = {
			files: {},
			analysisCompleted : false,
			gtfsFullFlex : false,
			analysisLaunchTime : null,
			analysisJob : null,
			analysisDate : null,
			analysisData : {},
			importData : {
				analysisJobId: null,
				description : "emptyDescription",
				cleanMode : null,
				routeMerge : false,
				generateMapMatching : "NONE",
				routesReorganization : false,
				routeSortOrder : false,
				netexImportLayouts : false,
				netexImportColors : false,
				splitCharacter : null,
				commercialPointIdPrefixToRemove : null,
				quayIdPrefixToRemove : null,
				linePrefixToRemove : null,
				name : null,
				ignoreCommercialPoints : null,
				areaCentroidPrefixToRemove : null,
				stopAreaPrefixToRemove : null,
				updateStopAccessibility : true,
				useTargetNetwork : false,
				targetNetwork : null,
				renameRoutesAfterMerge : false,
				importFareFiles: false,
				recomputeStopPlacesLocation : true,
				allowNonStandardGtfs: false,
				fillMissingStopName: '',
				fillMissingCoordinates: '',
				overwriteLineInformation: true,
				allowGtfsFlex: false,
				gtfsFlexOnly: false
			},
			actionReport : {
				action_report: {
					failure: null,
					result: null,
					files: [],
					filesInError: []
				}
			},
			type : null,
			analysisInError : false,
			analysisNumber : null,
			fileClassificationFailureEvents : [],
			fileClassificationError: {
				display : false,
				job : {
					username: "",
					fileName: "",
					type: "",
				}
			}
		};

		let refId, timeoutImportData;
		$scope.isPageInitialized = false;



		$scope.data.analysisLaunchTime =  SharedProperties.getAttribute("analysisLaunchTime");
		$scope.data.analysisDate =  SharedProperties.getAttribute("analysisDate");
		let savedImportData =  SharedProperties.getAttribute("importData");
		if (savedImportData !== undefined && savedImportData != null){
			$scope.data.importData = savedImportData;
		}

		$scope.data.type =  SharedProperties.getAttribute("type");
		$scope.data.fileName =  SharedProperties.getAttribute("fileName");
		$scope.data.importData.analysisJobId = SharedProperties.getAttribute("analysisJobId");
		$scope.data.importData.description = SharedProperties.getAttribute("fileDescription");
		$scope.data.importData.cleanMode = SharedProperties.getAttribute("cleanMode");
		$scope.data.importData.routeMerge =  SharedProperties.getAttribute("routeMerge");
		$scope.data.importData.generateMapMatching =  SharedProperties.getAttribute("generateMapMatching");
		$scope.data.importData.routesReorganization =  SharedProperties.getAttribute("routesReorganization");
		$scope.data.importData.routeSortOrder = SharedProperties.getAttribute("routeSortOrder");
		$scope.data.importData.netexImportLayouts = SharedProperties.getAttribute("netexImportLayouts");
		$scope.data.importData.netexImportColors = SharedProperties.getAttribute("netexImportColors");
		$scope.data.importData.splitCharacter =  SharedProperties.getAttribute("splitCharacter");
		$scope.data.importData.commercialPointIdPrefixToRemove =  SharedProperties.getAttribute("commercialPointIdPrefixToRemove");
		$scope.data.importData.quayIdPrefixToRemove =  SharedProperties.getAttribute("quayIdPrefixToRemove");
		$scope.data.importData.linePrefixToRemove =  SharedProperties.getAttribute("linePrefixToRemove");
		$scope.data.importData.name =  SharedProperties.getAttribute("importName");
		$scope.data.importData.ignoreCommercialPoints =  SharedProperties.getAttribute("ignoreCommercialPoints");
		$scope.data.importData.areaCentroidPrefixToRemove =  SharedProperties.getAttribute("areaCentroidPrefixToRemove");
		$scope.data.importData.stopAreaPrefixToRemove =  SharedProperties.getAttribute("stopAreaPrefixToRemove");
		$scope.data.importData.keepBoardingAlightingPossibility =  SharedProperties.getAttribute("keepBoardingAlightingPossibility");
		$scope.data.importData.keepStopGeolocalisation =  SharedProperties.getAttribute("keepStopGeolocalisation");
		$scope.data.importData.keepStopNames =  SharedProperties.getAttribute("keepStopNames");
		$scope.data.importData.removeParentStations =  SharedProperties.getAttribute("removeParentStations");
		$scope.data.importData.importShapesFile =  SharedProperties.getAttribute("importShapesFile");
		$scope.data.importData.updateStopAccessibility =  SharedProperties.getAttribute("updateStopAccessibility");
		$scope.data.importData.railUICProcessing =  SharedProperties.getAttribute("railUICprocessing");
		$scope.data.importData.distanceGeolocation =  SharedProperties.getAttribute("distanceGeolocation");
		$scope.data.importData.useTargetNetwork =  SharedProperties.getAttribute("useTargetNetwork");
		$scope.data.importData.targetNetwork =  SharedProperties.getAttribute("targetNetwork");
		$scope.data.importData.renameRoutesAfterMerge =  SharedProperties.getAttribute("renameRoutesAfterMerge");
		$scope.data.importData.importFareFiles = SharedProperties.getAttribute("importFareFiles");
		$scope.data.importData.recomputeStopPlacesLocation =  SharedProperties.getAttribute("recomputeStopPlacesLocation");
		$scope.data.importData.allowNonStandardGtfs =  SharedProperties.getAttribute("allowNonStandardGtfs");
		$scope.data.importData.fillMissingStopName =  SharedProperties.getAttribute("fillMissingStopName");
		$scope.data.importData.fillMissingCoordinates =  SharedProperties.getAttribute("fillMissingCoordinates");
		$scope.data.importData.overwriteLineInformation = SharedProperties.getAttribute("overwriteLineInformation");
		$scope.data.importData.allowGtfsFlex = SharedProperties.getAttribute("allowGtfsFlex");



		if ($scope.data.importData === null || $scope.data.importData === undefined){
			$location.path("data-management/imports/new");
		}

		AdminClientsService.getReferentialIdAndUser().then((referential) => {
				$scope.data.currentReferential =  referential;
			});



		$scope.launchImport = function(){
			let importData = $scope.data.importData;
			if ($scope.data.currentReferential === null || $scope.data.currentReferential === undefined){
				return;
			}
			if ($scope.data.gtfsFullFlex) {
				// No chouette analysisJobId exists for a GTFS-Flex-only file: identify it by fileName instead
				importData.gtfsFlexOnly = true;
				importData.fileName = $scope.data.fileName;
			}
			AdminClientsService.getCurrentClient().then((client) => {
				importData = OpenImportsService.feedImportData(importData,client);
				OpenImportsService.postImport($scope.data.type, $scope.data.importData, $scope.data.currentReferential.id, $scope.data.currentReferential.user)
					.then(() => {
						$scope.data.fileClassificationError.display = false;
						toastr.success("", "Import démarré");
						$location.path("data-management/imports/");
					});
			});
		};

		/*
		 * Récupère l'état de tous les imports du référentiel courant
		*/
		let getAnalyzeData = function () {

			if ($scope.data.currentReferential === undefined || $scope.data.currentReferential === null){
				return;
			}
			OpenImportsService.getMobiitiImports(refId)
				.then((response) => {
					$scope.data.analyzes = response.data.filter(importData =>  hasAnalyzeProcessInEvents(importData)).sort(reverseFirstEventSorter);
					$scope.data.fileClassificationFailureEvents = response.data.filter(importData =>  hasFileClassificationFailureEvent(importData)).sort(reverseFirstEventSorter);
					handleEventDataReceveived();

					if (($scope.analysisData !== undefined && $scope.analysisData !== null)
						|| $scope.data.analysisInError
						|| $scope.data.fileClassificationError.display
					){
						$scope.data.fileClassificationFailureEvents = [];
						$timeout.cancel(timeoutImportData);

					}
				})
				.catch(() => {
					$scope.data.fileClassificationFailureEvents = [];
					timeoutImportData = $timeout(() => getAnalyzeData(), 5000);
				});
		};



		AdminClientsService.getReferentialId().then((data) => {
			refId = data;
			getAnalyzeData();
		});



		/**
		 * Read the data received from event table, check if the received data contains analysis for the file sent by user
		 * and decides if the process has to wait for data or stop receive data
		 */
		let handleEventDataReceveived = function () {
			if (Array.isArray($scope.data.analyzes) && $scope.data.analyzes.length > 0){
				let firstAnalyze  = $scope.data.analyzes[0]; // most recent analysis from backend
				let launchTime = Date.parse($scope.data.analysisLaunchTime);
				// check whether user clicked check last analysis or user new analysis request is over
				if (isNaN(launchTime) || firstAnalyze.lastEvent >  launchTime) {
					$scope.data.analysisCompleted = true;
					$scope.data.analysisJob = firstAnalyze;
					// analysisDate has not been set yet if user clicked check last analysis
					// we need to set it there
					$scope.data.analysisDate = new Date(firstAnalyze.lastEvent);
					if (isGtfsFullFlexOnly(firstAnalyze)) {
						$scope.data.gtfsFullFlex = true;
						$scope.isPageInitialized = true;
					} else {
						feedAnalysisDataToScope(firstAnalyze);
					}
					return;
				} else if ($scope.data.fileClassificationFailureEvents.length) {
					let classification  = $scope.data.fileClassificationFailureEvents[0];
					if (isNaN(launchTime) || classification.lastEvent >  launchTime) {
						$scope.data.fileClassificationError.display = true;
						$scope.data.fileClassificationError.job = classification;
					}
				}

			}

			// Data received from back end does not contain analysis of the file sent by user. We have to check again in 5s
			timeoutImportData = $timeout(() => getAnalyzeData(), 5000);
		};

		$scope.generateImportDetailsUrl = function (imprt) {
			if (imprt == null){
				return;
			}

			const event = imprt.events.find(event => event.action === "FILE_ANALYZE" && event.chouetteJobId);
			if (event) {
				return "#/data-management/imports/" + event.referential + "/" + event.chouetteJobId;
			}
		};

		let hasAnalyzeProcessInEvents = function(importData){
			return importData.events.some(event => event.action.includes('FILE_ANALYZE') && event.state !== 'STARTED' && event.state !== 'PENDING' && event.state !== 'CANCELED');
		}

		let hasFileClassificationFailureEvent = function(importData){
			return importData.events.some(event => event.action.includes('FILE_CLASSIFICATION') && event.state === "FAILED");
		}

		let isGtfsFullFlexOnly = function(analyzeJob){
			return analyzeJob.events.some(event => event.type === 'GTFS_FULL_FLEX');
		}

		let feedAnalysisDataToScope = function (analysisJob) {

			let analysisEvent = analysisJob.events.find(event => event.chouetteJobId != null);
			let chouetteId = analysisEvent.chouetteJobId;

			if (chouetteId == null) {
				//Problem on analysis recovery. Re activating data recover from back end
				timeoutImportData = $timeout(() => getAnalyzeData(), 5000);
				return;
			}

			if ($scope.data.analysisNumber === null || $scope.data.analysisNumber === undefined){
				OpenImportsService.getAnalysisReport(analysisEvent.referential, chouetteId)
					.then((response) => {
						$scope.analysisData = response.data;
						formatModifiedTimetables();
						if ($scope.analysisData.analyze_report.tooManyNewStops) {
							$scope.status.isNewStopsOpen = true;
						}
						$scope.data.analysisNumber = chouetteId;
					});

				OpenImportsService.getActionParameters(analysisEvent.referential, chouetteId)
					.then((response) => {
						const data = response.data;
						let parameters;

						if (data["gtfs-import"]){
							parameters = data["gtfs-import"];
						}

						if (data["neptune-import"]){
							parameters = data["neptune-import"];
							$scope.data.type = "neptune";
						}

						if (data["netexprofile-import"]){
							parameters = data["netexprofile-import"];
						}

						//scope variable "cleanRepository" represents the checkbox whereas parameters.cleanRepository represents if the db must be cleaned : ticked => no clean, no ticked => clean
						// that's why we need to negate the variable read from action_parameters.json
						$scope.data.importData.cleanMode =  parameters.clean_mode;
						$scope.data.importData.routeMerge =  parameters.route_merge;
						$scope.data.importData.generateMapMatching =  parameters.generate_map_matching;
						$scope.data.importData.routesReorganization = parameters.routes_reorganization;
						$scope.data.importData.routeSortOrder = parameters.route_sort_order;
						$scope.data.importData.netexImportLayouts = parameters.netex_import_layouts;
						$scope.data.importData.netexImportColors = parameters.netex_import_colors;
						$scope.data.importData.splitCharacter =  parameters.split_character;
						$scope.data.importData.commercialPointIdPrefixToRemove =  parameters.commercial_point_prefix_to_remove;
						$scope.data.importData.quayIdPrefixToRemove =  parameters.quay_id_prefix_to_remove;
						$scope.data.importData.linePrefixToRemove =  parameters.line_prefix_to_remove;
						$scope.data.importData.name =  parameters.name;
						$scope.data.importData.ignoreCommercialPoints =  parameters.ignore_commercial_points;
						$scope.data.importData.areaCentroidPrefixToRemove =  parameters.areaCentroid_prefix_to_remove;
						$scope.data.importData.stopAreaPrefixToRemove =  parameters.stopArea_prefix_to_remove;
						$scope.data.importData.keepStopNames =  parameters.keep_stop_names;
						$scope.data.importData.removeParentStations =  parameters.remove_parent_stations;
						$scope.data.importData.importShapesFile =  parameters.import_shapes_file;
						$scope.data.importData.useTargetNetwork = parameters.use_target_network;
						$scope.data.importData.targetNetwork = parameters.target_network;
						$scope.data.importData.renameRoutesAfterMerge = parameters.rename_routes_after_merge;
						$scope.data.importData.importFareFiles = parameters.import_fare_files;
						$scope.data.importData.recomputeStopPlacesLocation = parameters.recompute_stop_places_location;
						$scope.data.importData.overwriteLineInformation = parameters.overwrite_line_information;
					});
			}
			$scope.data.importData.analysisJobId = chouetteId;
			$scope.data.importData.referential = analysisEvent.referential;
			$scope.isPageInitialized = true;

			OpenImportsService.getActionReport($scope.data.importData.referential, $scope.data.importData.analysisJobId).then((response) => {
				$scope.data.actionReport = response.data;
			});

		};

		let reverseFirstEventSorter = function (obj1, obj2) {
			if (obj1.firstEvent > obj2.firstEvent) return -1;
			if (obj1.firstEvent < obj2.firstEvent) return 1;
			return 0;
		};

		let formatModifiedTimetables = function () {
			if ($scope.analysisData.analyze_report.modifiedTimetables === undefined || $scope.analysisData.analyze_report.modifiedTimetables == null || $scope.analysisData.analyze_report.modifiedTimetables.length === 0){
				return;
			}
			$scope.analysisData.formattedModifiedTimetables = [];
			$scope.analysisData.analyze_report.modifiedTimetables.forEach(timetable => addModifiedTimetableToFormatedData(timetable));
		};

		let addModifiedTimetableToFormatedData = function (modifiedTimeTable) {
			let line = {};
			line.firstCol = modifiedTimeTable.timetableName;
			$scope.analysisData.formattedModifiedTimetables.push(line);
			formatTimeTable(modifiedTimeTable.existingPeriods, modifiedTimeTable.incomingPeriods);
			formatTimeTable(modifiedTimeTable.existingDates, modifiedTimeTable.incomingDates);
		};

		let formatTimeTable = function (existingDataArray, incomingDataArray) {

			if (existingDataArray !== undefined && existingDataArray !== null && existingDataArray.length > 0){
				for(let existingData of existingDataArray){
					let dataLine = {};
					dataLine.secondCol = existingData;

					let incomingPeriod = incomingDataArray.find(element => element === existingData);

					if (incomingPeriod !== null && incomingPeriod !== undefined){
						dataLine.thirdCol = incomingPeriod;
						incomingDataArray = arrayRemove(incomingDataArray, incomingPeriod);
					}
					$scope.analysisData.formattedModifiedTimetables.push(dataLine);
				}
			}

			//All data from existingPeriod has been processed. Now, need to format data remaining in incomingPeriods
			let i = 0;
			for(let incomingData of incomingDataArray){
				let dataLine = {};
				dataLine.thirdCol = incomingData;
				$scope.analysisData.formattedModifiedTimetables.push(dataLine);
				i++;
				if(i > 20){
					dataLine.thirdCol = "... (+" + (incomingDataArray.length - 20) + " dates)";
					$scope.analysisData.formattedModifiedTimetables.push(dataLine.thirdCol);
					break;
				}
			}
		};

		let arrayRemove =  function (array, value) {
			return array.filter(function(element){
				return element != value;
			});
		};

		$scope.getCssStyleForLine = function (line) {
			const lineTextColor = $scope.getLineTextColor(line);
			const backgroundColor = $scope.getLineBackgroundColor(line);
			return {
				'color': lineTextColor,
				'background-color': backgroundColor,
				'text-align': 'center'
			};
		};

		$scope.getLineTextColor = function (line) {
			if (!line || !line.lineTextColor || (line.lineTextColor === "000000" && line.lineBackgroundColor === "000000")) {
				return "#FFFFFF";
			} else if (line.lineTextColor === line.lineBackgroundColor) {
				return "#000000";
			} else {
				return "#" + line.lineTextColor;
			}
		};

		/**
		 * Retourne la couleur de fond de la ligne
		 * @param line
		 * @returns {string}
		 */
		$scope.getLineBackgroundColor = function (line) {
			if (!line) {
				return "#000000";
			}
			return "#" + line.lineBackgroundColor;
		};

		$scope.openLocationErrorHelpModal = function () {
			Utils.openModal($uibModal, "locationErrorHelpModal.html", $scope);
		}


		$scope.canLaunchImport = function () {
			if ($scope.data.gtfsFullFlex) {
				return true;
			}
			if ($scope.analysisData === undefined || $scope.analysisData.analyze_report == null || $scope.analysisData.analyze_report === undefined){
				return false;
			}

			let canLaunchImport = $scope.analysisData.analyze_report.canLaunchImport;
			return canLaunchImport == null || canLaunchImport == undefined || canLaunchImport;
		}

		$scope.splitToSymbol = function(result, symbol) {
			return result.split(symbol);
		};

		$scope.mapSize = function(value) {
			let size = 0;
			for (const key in value) {
				size = size+1;
			}
			return size;
		}

		$scope.getDuplicateTripStructureEntries = function() {
			const data = $scope.analysisData.analyze_report.duplicateTripStructureInStopTimesWithSameHourlyAndStop;

			if (data) {
				// Transform the object into an array of { times: key, tripIds: values }
				return Object.entries(data).map(([times, tripIds]) => {
					return { times: times, tripIds: tripIds };
				});
			}
			return [];
		};

		$scope.downloadTxt = function () {
			let textContent = '';
			JSON.parse(angular.toJson($scope.analysisData.analyze_report.stopPointsPassingTimesDifference)).forEach(result => {
				for (const [key, values] of Object.entries(result)) {
					textContent += `Pour le ServiceJourneyPattern : ${key}\n\n`;

					if (Array.isArray(values)) {
						values.forEach(resultvalues => {
							textContent += `--> Nous avons un total de ${resultvalues.stopPointsSize} StopPointInJourneyPattern,\n`;
							textContent += `or le ServiceJourney associé ${resultvalues.serviceJourneyId} possède ${resultvalues.passingTimesSize} PointInJourneyPatternRef,\n`;
							textContent += `ce qui ne convient pas pour l'import, car on ne peut pas avoir ${resultvalues.stopPointsSize} StopPointInJourneyPattern pour un ServiceJourney qui contient ${resultvalues.passingTimesSize} PointInJourneyPatternRef.\n\n`
						});
					}
				}
				textContent += '\n----------------------------------------\n\n';
			});

			const blob = new Blob([textContent], { type: 'text/plain' });
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = 'analyze_PointInJourneyPattern_not_present_in_ServiceJourneyPattern.txt';
			link.click();
		};




	}]);
